<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M14,0C14,0,4,0,4,0C3.45,0,3,0.45,3,1C3,1,3,4,3,4C3,4,5,4,5,4C5,4,5,2,5,2C5,2,8,2,8,2C8,2,8,14,8,14C8,14,5,14,5,14C5,14,5,12,5,12C5,12,3,12,3,12C3,12,3,15,3,15C3,15.55,3.45,16,4,16C4,16,14,16,14,16C14.55,16,15,15.55,15,15C15,15,15,1,15,1C15,0.45,14.55,0,14,0C14,0,14,0,14,0ZM13,14C13,14,10,14,10,14C10,14,10,2,10,2C10,2,13,2,13,2C13,2,13,14,13,14C13,14,13,14,13,14ZM4.29,10.71C4.47,10.89,4.72,11,5,11C5.55,11,6,10.55,6,10C6,9.72,5.89,9.47,5.71,9.29C5.71,9.29,4.41,8,4.41,8C4.41,8,5.7,6.71,5.7,6.71C5.89,6.53,6,6.28,6,6C6,5.45,5.55,5,5,5C4.72,5,4.47,5.11,4.29,5.29C4.29,5.29,3,6.59,3,6.59C3,6.59,1.71,5.29,1.71,5.29C1.53,5.11,1.28,5,1,5C0.45,5,0,5.45,0,6C0,6.28,0.11,6.53,0.29,6.71C0.29,6.71,1.59,8,1.59,8C1.59,8,0.29,9.29,0.29,9.29C0.11,9.47,0,9.72,0,10C0,10.55,0.45,11,1,11C1.28,11,1.53,10.89,1.71,10.71C1.71,10.71,3,9.41,3,9.41C3,9.41,4.29,10.71,4.29,10.71C4.29,10.71,4.29,10.71,4.29,10.71Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'RemoveColumn',
} as DefineComponent
</script>
